export async function uninstallFilter(_client,{filter:filter}){return filter.request({method:"eth_uninstallFilter",params:[filter.id]})}